import { render, staticRenderFns } from "./AwardScorePreview.vue?vue&type=template&id=3062680b"
import script from "./AwardScorePreview.vue?vue&type=script&lang=js"
export * from "./AwardScorePreview.vue?vue&type=script&lang=js"
import style0 from "./AwardScorePreview.vue?vue&type=style&index=0&id=3062680b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports